const {isArray} = Array;

export const maybeArray = (a: any) => isArray(a) ? a : [a];
